import React from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import {
  Container,
  Row,
  Col,
  Breadcrumb,
  Tab,
  Tabs,
  Card,
  Accordion,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import bannerImage from "../../Images/student-services/research-banner.webp";
import Allinone from "../common/Allinone.js";

const Research = () => {
  return (
    <React.Fragment>
      <title>A Decade of Innovation & Research at ISBM University</title>
      <meta
        name="description"
        content="ISBM University drives cutting-edge research, breakthrough discoveries, and global collaborations, shaping the future of knowledge and industry."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(77, 77, 77, 0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Research Programs (PHD)</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Research
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="research-overview ptb-50">
        <div className="container-xxl">
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="research-intro mb-5">
                <p className="text-center">
                  <b>Research at ISBM University lies at the heart of its academic
                    mission, reflecting a deep-rooted commitment to innovation,
                    intellectual growth, and social impact.</b> The University
                  believes that knowledge creation is not just an academic
                  pursuit but a powerful tool for driving positive change in
                  society. Through a blend of theoretical and applied research,
                  ISBM encourages its faculty and students to explore new ideas,
                  challenge conventions, and contribute meaningfully to their
                  respective disciplines.
                </p>
                <p className="text-center">
                  <b>A vibrant and inclusive research culture thrives across all
                    schools and departments, fostering creativity, critical
                    thinking, and scientific inquiry.</b> The University supports
                  research initiatives across a diverse range of fields—ranging
                  from business, management, and technology to health sciences,
                  education, and social development. By prioritizing both
                  fundamental and applied research, ISBM ensures that its
                  academic efforts are both intellectually rigorous and
                  practically relevant, preparing students to contribute
                  solutions to real-world challenges.
                </p>
                <p className="text-center">
                  <b>Collaboration and interdisciplinary engagement are key pillars
                    of ISBM's research ecosystem.</b> The University actively promotes
                  partnerships between departments and encourages joint ventures
                  with national and international institutions, industries, and
                  government bodies. These collaborations enhance the scope and
                  impact of research projects, allowing scholars to address
                  complex global issues through a holistic and cross-functional
                  lens. ISBM University remains committed to nurturing research
                  that not only enriches academia but also creates tangible
                  benefits for society at large.
                </p>
              </div>

              {/* Key Research Aspects */}
              <div className="research-aspects mb-5">
                <h2 className="modern-title section-title text-center text-blue">
                  Key Aspects of Our Research Environment
                </h2>

                <Row className="g-4">
                  <Col md={6} lg={4}>
                    <div className="feature-card p-4 h-100 bg-white rounded shadow-sm">
                      <div className="feature-icon mb-3 text-primary">
                        <i className="ti ti-users-group feature-icon-style"></i>
                      </div>
                      <h4>Interdisciplinary Approach</h4>
                      <p>
                        Encouraging collaboration across different faculties and
                        departments to address complex, multifaceted problems,
                        resulting in innovative solutions and comprehensive
                        insights.
                      </p>
                    </div>
                  </Col>

                  <Col md={6} lg={4}>
                    <div className="feature-card p-4 h-100 bg-white rounded shadow-sm">
                      <div className="feature-icon mb-3 text-primary">
                        <i className="ti ti-microscope feature-icon-style"></i>
                      </div>
                      <h4>State-of-the-Art Facilities</h4>
                      <p>
                        Providing researchers with access to modern
                        laboratories, advanced equipment, and cutting-edge
                        technology to support high-quality research endeavours.
                      </p>
                    </div>
                  </Col>

                  <Col md={6} lg={4}>
                    <div className="feature-card p-4 h-100 bg-white rounded shadow-sm">
                      <div className="feature-icon mb-3 text-primary">
                        <i className="ti ti-school feature-icon-style"></i>
                      </div>
                      <h4>Experienced Faculty</h4>
                      <p>
                        Engaging a team of distinguished scholars and
                        researchers who guide and mentor students, helping them
                        to develop their research skills and pursue impactful
                        projects.
                      </p>
                    </div>
                  </Col>

                  <Col md={6} lg={4}>
                    <div className="feature-card p-4 h-100 bg-white rounded shadow-sm">
                      <div className="feature-icon mb-3 text-primary">
                        <i className="ti ti-news feature-icon-style"></i>
                      </div>
                      <h4>Publication and Dissemination</h4>
                      <p>
                        Promoting the dissemination of research findings through
                        publications in reputable journals, presentations at
                        international conferences, and participation in academic
                        forums.
                      </p>
                    </div>
                  </Col>

                  <Col md={6} lg={4}>
                    <div className="feature-card p-4 h-100 bg-white rounded shadow-sm">
                      <div className="feature-icon mb-3 text-primary">
                        <i className="ti ti-link feature-icon-style"></i>
                      </div>
                      <h4>Partnerships and Collaborations</h4>
                      <p>
                        Building strong connections with industry, government
                        agencies, and other academic institutions to foster
                        collaborative research initiatives and apply research
                        outcomes to real-world challenges.
                      </p>
                    </div>
                  </Col>

                  <Col md={6} lg={4}>
                    <div className="feature-card p-4 h-100 bg-white rounded shadow-sm">
                      <div className="feature-icon mb-3 text-primary">
                        <i className="ti ti-user-star feature-icon-style"></i>
                      </div>
                      <h4>Student Involvement</h4>
                      <p>
                        Encouraging student participation in research projects
                        to enhance their learning experience, develop critical
                        thinking skills, and prepare them for careers in
                        academia, industry, or other research-intensive fields.
                      </p>
                    </div>
                  </Col>

                  <Col md={6} lg={4} className="mx-auto">
                    <div className="feature-card p-4 h-100 bg-white rounded shadow-sm">
                      <div className="feature-icon mb-3 text-primary">
                        <i className="ti ti-shield-check feature-icon-style"></i>
                      </div>
                      <h4>Ethical Standards</h4>
                      <p>
                        Upholding the highest ethical standards in research,
                        ensuring integrity, transparency, and accountability in
                        all research activities.
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <section className="ptb-50 bg-light">
        <div className="container-xxl">
          <div className="text-center">
            <h2 className="text-blue section-title modern-title">
              Outcome of the Research Activities in the University
            </h2>
          </div>
          <p className="mb-5">
            {" "}
            The Doctor of Philosophy (Ph.D.) programs will give an opportunity
            to the students to undertake advanced studies in the subject in
            which he or she has already acquired post-graduation.
          </p>
          <div id="outcomes" className="overview">
            <ul>
              <li>
                These programs are focused on creating free thinkers—individuals
                who are independent in their thinking, loyalty, and commitment.
              </li>
              <li>
                The prime focus of the programs offered is to promote the
                effective integration of technology with state-of-the-art
                facilities in teaching and research activities.
              </li>
              <li>
                The curriculum offered and learning pedagogy focuses on
                problem-solving and decision-making, thus creating honed
                analytical skills coupled with knowledge and application of
                various emerging trends in the fields of Management & Commerce,
                Science, Arts, and Humanities.
              </li>
              <li>
                The broad objectives of the research program are to keep pace
                with the expanding frontiers of knowledge in conformity with the
                requirements of mankind.
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          <Row>
            <Col lg={12}>
              <div className="evaluation-system ">
                <h2 className="modern-title section-title-start text-blue">
                  ISBM University: Public Statement Detailing Our Commitment to DORA
                </h2>
                <p>ISBM University is proud to be a signatory of the Declaration on Research Assessment (DORA).</p>
                <p>
                  DORA is a global initiative that emphasizes the importance of advancing research evaluation
                  practices by encouraging the responsible use of metrics and providing strategic recommendations
                  for more effective and equitable assessment At ISBM University, reforming research assessment
                  is a key priority, enabling us to cultivate and sustain a vibrant research culture. Through this
                  approach, we ensure our researchers are well-supported in achieving their full potential, while
                  strengthening both the quality and impact of our research
                </p>
                <p>
                  In alignment with our commitments to DORA, ISBM University will establish a Research Assessment
                  Reform Working Group. This group will be responsible for formulating and implementing a statement
                  on responsible research assessment, as well as developing a comprehensive action plan to drive the
                  reform of research evaluation across the University ISBM University is committed to
                  embedding the principles of DORA across all its activities. For any enquiries regarding DORA
                  or our research assessment reform initiatives, please contact Dr Trilok.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <Allinone />
      <Footer />
    </React.Fragment>
  );
};

export default Research;
